import {useState, useEffect} from 'react'
import { TextField } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import config from '../../../../utils/config';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const validerHeures = (disponibilites) => {
  for (const jour in disponibilites) {
    const { heureDebut, heureFin } = disponibilites[jour];
    if (!heureDebut || !heureFin) {
      return false;
    }
  }
  return true;
};

const jours = [
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
  'Dimanche',
];

const parseJoursFromParent = (joursDisponibles) => {
  if (!joursDisponibles || typeof joursDisponibles !== 'string') return [];
  return joursDisponibles.split(',').map((s) => s.trim()).filter(Boolean);
};

const parseDisponibilitesFromParent = (periodeJournee, joursNameArr) => {
  let base = {};
  try {
    if (periodeJournee && typeof periodeJournee === 'string') {
      const parsed = JSON.parse(periodeJournee);
      if (parsed && typeof parsed === 'object') base = parsed;
    }
  } catch (e) {}
  const result = { ...base };
  (joursNameArr || []).forEach((jour) => {
    if (!result[jour]) result[jour] = { heureDebut: '', heureFin: '' };
  });
  return result;
};

const Step4 = props => {

    const { 
      lieuTravail,
      ville,
      setVille,
      setLieuTravail,
      cycleEleve,
      setCycleEleve,
      quartierResidence,
      setQuartierResidence,
      villeResidence,
      setVilleResidence,
      arrondissementResidence,
      setArrondissementResidence,
      difficulte,
      setDifficulte,
      periodeJournee,
      setPeriodeJournee,
      joursDisponibles,
      setJoursDisponibles,
      setShowBtn,
      setError
    } = props;
    
    const [joursName, setJoursName] = useState(() => parseJoursFromParent(props.joursDisponibles));
    const [disponibilites, setDisponibilites] = useState(() =>
      parseDisponibilitesFromParent(props.periodeJournee, parseJoursFromParent(props.joursDisponibles))
    );
    const [heureSaisie, setHeureSaisie] = useState(false);
    const [quartiersStructure, setQuartiersStructure] = useState(null);

    useEffect(() => {
      const v = (ville || '').trim();
      if (!v) {
        setQuartiersStructure(null);
        setQuartierResidence('');
        setVilleResidence('');
        setArrondissementResidence('');
        return;
      }
      // Quand le département change, on reset la sélection de résidence (quartier + dérivés)
      setQuartierResidence('');
      setVilleResidence('');
      setArrondissementResidence('');
      const url = `${config.apiUrl}/comptes/quartiers/structure/?ville=${encodeURIComponent(v)}`;
      fetch(url)
        .then((r) => r.json())
        .then((data) => setQuartiersStructure(data?.structure || null))
        .catch(() => setQuartiersStructure(null));
    }, [ville]);

    const [msgHeuresSaisies, setMsgHeuresSaisies] = useState("");
    const [msgLieuTravail, setMsgLieuTravail] = useState('');
    const [msgVille, setMsgVille] = useState('');
    const [msgCycleEleve, setMsgCycleEleve] = useState('');
    const [msgQuartierResidence, setMsgQuartierResidence] = useState('');
    const [msgDifficulte, setMsgDifficulte] = useState('');
    const [msgJoursDisponibles, setMsgJoursDisponibles] = useState('');
    const [showValidation, setShowValidation] = useState(false);

    const handleChangeJours = (e) => {

      const {
        target: { value },
      } = e;
      setJoursName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
  
      const selectedDays = e.target.value;
      const updatedDisponibilites = {};
      selectedDays.forEach((day) => {
        if (!disponibilites[day]) {
          updatedDisponibilites[day] = {
            heureDebut: "",
            heureFin: "",
          };
        } else {
          updatedDisponibilites[day] = disponibilites[day];
        }
      });
      setDisponibilites(updatedDisponibilites);
    };

    useEffect(() => {
      const updatedHeureSaisie = validerHeures(disponibilites);
      setHeureSaisie(updatedHeureSaisie);
    }, [disponibilites])



    const handleChange = (e, jour) => {
      const { name, value } = e.target;
  
      if(value !== ""){
  
      let updatedValue = value; // Utilisez une variable let pour la valeur
      // Validation de l'heure de début
      if (name === "heureDebut") {
        const heureDebut = value.slice(0, 2);
        const minuteDebut = value.slice(3, 5);
        const heureFin = disponibilites[jour]?.heureFin?.slice(0, 2) || "";
        const minuteFin = disponibilites[jour]?.heureFin?.slice(3, 5) || "";
        if (heureDebut < "07" || heureDebut > "18") {
          // L'heure de début est inférieure à 7h, ajustement à 7h
          updatedValue = "07" + value.slice(2);
        }else if (heureDebut == "18"){
          updatedValue = "18" + value.slice(2);
        }
        else if (heureFin && heureDebut > heureFin) {
          let h = Number(heureFin) - 2
          if((h+"").length === 1){
            h = "0"+h          
          }
          updatedValue = h + value.slice(2);
        }else if (heureDebut === heureFin){
          setHeureSaisie(false)
          
          let h = Number(heureDebut) - 2
          if((h+"").length === 1){
            h = "0"+h          
          }
          updatedValue = h +":"+minuteDebut;
          if (minuteDebut > minuteFin){
            updatedValue = heureDebut+":"+minuteFin 
          }
        }else{
          if(heureFin !== "" && minuteFin !== ""){
            const diffHours = heureFin - heureDebut;
            
            if(diffHours === 2){
              disponibilites[jour].heureFin = heureFin+":"+minuteDebut
            }
  
            if (diffHours < 2) {
              // L'écart entre l'heure de début et l'heure de fin est inférieur à 2 heures
              let h = Number(heureFin) - 2
              if((h+"").length === 1){
                h = "0"+h          
              }
              updatedValue = h +":"+minuteFin;
              // Tu peux également afficher un message d'erreur approprié
              // setError("L'écart entre l'heure de début et l'heure de fin doit être d'au moins 2 heures.");
            }
          }
        }
      }
      
  
      // Validation de l'heure de fin
      if (name === "heureFin") {
        const heureFin = value.slice(0, 2);
        const minuteFin = value.slice(3, 5);
        const heureDebut = disponibilites[jour]?.heureDebut?.slice(0, 2) || "";
        const minuteDebut = disponibilites[jour]?.heureDebut?.slice(3, 5) || "";
  
        if (heureFin > "18" || heureFin < "07") {
          // L'heure de fin est supérieure à 18h, ajustement à 18h
          updatedValue = "18" + value.slice(2);
        } else if (heureDebut && heureFin < heureDebut) {
          // L'heure de fin est inférieure à l'heure de début, ajustement à l'heure de début actuelle
          updatedValue = heureDebut + value.slice(2);
        }else if (heureDebut === heureFin){
          let h = Number(heureFin) + 2
          if((h+"").length === 1){
            h = "0"+h          
          }
          updatedValue = h + value.slice(2);
          if (minuteFin < minuteDebut){
            updatedValue = heureFin+":"+minuteDebut 
          }
        }else{
          if(heureDebut !== "" && minuteDebut !== ""){
            const diffHours = heureFin - heureDebut;
            if (diffHours < 2) {
              // L'écart entre l'heure de début et l'heure de fin est inférieur à 2 heures
              let h = Number(heureFin) + 1
              if((h+"").length === 1){
                h = "0"+h          
              }
              updatedValue = h + value.slice(2);
              // Tu peux également afficher un message d'erreur approprié
              // setError("L'écart entre l'heure de début et l'heure de fin doit être d'au moins 2 heures.");
            }
          }
        }
      }
  
      setDisponibilites((prevState) => ({
        ...prevState,
        [jour]: {
          ...prevState[jour],
          [name]: updatedValue,
        },
      }));
  
    }
    
    };


    const handleChangeLieuTravail = (e) => {
      setShowValidation(true);
      setLieuTravail(e);
    };

    const handleVille = (e) => {
      setShowValidation(true);
      setVille(e.target.value);
      setQuartierResidence('');
      setVilleResidence('');
      setArrondissementResidence('');
    };

    const toggleCycle = (value) => {
      setShowValidation(true);
      const arr = (cycleEleve || '').split(',').filter(Boolean);
      const next = arr.includes(value) ? arr.filter(c => c !== value) : [...arr, value];
      setCycleEleve(next.join(','));
    };

  
    const cycleEleveArray = (cycleEleve || '').split(',').filter(Boolean);
    const cycleValid = cycleEleveArray.length >= 1;

    useEffect(() => {
      const ok =
        lieuTravail !== '' &&
        periodeJournee !== "" &&
        heureSaisie &&
        joursDisponibles !== "" &&
        cycleValid &&
        quartierResidence !== '' &&
        ville !== '' &&
        villeResidence !== '' &&
        arrondissementResidence !== '';
      setShowBtn(!!ok);
      // eslint-disable-next-line
    }, [
      lieuTravail,
      joursDisponibles,
      periodeJournee,
      difficulte,
      ville,
      villeResidence,
      arrondissementResidence,
      cycleEleve,
      quartierResidence,
      cycleValid,
      heureSaisie,
    ]);
    
    useEffect(() => {
      if (!showValidation) { setMsgLieuTravail(''); return; }
      setMsgLieuTravail(lieuTravail === '' ? "Adresse complète où vit l'enfant est obligatoire" : '');
    }, [lieuTravail, showValidation]);

    useEffect(() => {
      if (!showValidation) { setMsgVille(''); return; }
      setMsgVille(ville === "" ? "Le département est obligatoire" : "");
    }, [ville, showValidation]);

    useEffect(() => {
      if (!showValidation) { setMsgCycleEleve(''); return; }
      setMsgCycleEleve(cycleEleve ? '' : "Le cycle de l'élève est obligatoire");
    }, [cycleEleve, showValidation]);

    useEffect(() => {
      if (!showValidation) { setMsgQuartierResidence(''); return; }
      setMsgQuartierResidence(quartierResidence ? '' : "Le quartier de résidence est obligatoire");
    }, [quartierResidence, showValidation]);

    useEffect(() => {
      // champ optionnel: on n'affiche pas d'erreur même si vide
      if (!showValidation) {
        setMsgDifficulte('');
        return;
      }
      setMsgDifficulte('');
    }, [difficulte, showValidation]);

    useEffect(() => {
      if (joursName.length === 0) {
        setMsgJoursDisponibles("Les jours disponibles sont obligatoires");
      }else if (joursName.length < 2) {
        setMsgJoursDisponibles("Veuillez disposer d'au moins deux jours de disponibles");
      }
      else {
        setMsgJoursDisponibles("");
      }
      setJoursDisponibles(joursName.join(","))
    }, [joursName,setJoursDisponibles]);
  
    useEffect(() => {
      if(heureSaisie){
        setMsgHeuresSaisies("")
        setPeriodeJournee(JSON.stringify(disponibilites));
      }else{
        if(joursName.length >= 2){
          setMsgHeuresSaisies("Veuillez saisir toutes les heures où vous êtes disponibles")
        }
      }
    }, [heureSaisie,disponibilites,setPeriodeJournee,joursName])

    const handleSelect = async (selected) => {
      setLieuTravail(selected);
      try {
        const results = await geocodeByAddress(selected);
        const latLng = await getLatLng(results[0]);
        console.log('Latitude et longitude:', latLng);
      } catch (error) {
        console.error('Erreur de géocodage:', error);
      }
    };
  

    useEffect(() => {
        setMsgLieuTravail('')
        setMsgJoursDisponibles('')
        setMsgHeuresSaisies("");
        setMsgDifficulte('')
        setError('')
        // eslint-disable-next-line
    }, [])

    const selectedCity = (quartiersStructure?.villes || []).find((c) => c.ville === villeResidence) || null;
    const selectedArrondissement = selectedCity?.arrondissements?.find(
      (a) => a.arrondissement === arrondissementResidence
    ) || null;
    const quartiers = selectedArrondissement?.quartiers || [];

    return (
        <div className='text-center mt-4'>
              {/* <TextField
                type="text"
                name="ecole"
                label="Où vont travailler le prof et l'élève ?"
                className="w-100"
                value={lieuTravail}
                onChange={e => {
                  setLieuTravail(e.target.value)
                }}
                placeholder="Ex : 46 Rue missakou , Moukondo"
                variant="outlined"
                required
                error={Boolean(msgLieuTravail)}
                helperText={msgLieuTravail}
                style={{marginBottom: '20px'}}
              /> */}

              <FormControl sx={{ width: '100%' }}>
                <InputLabel id="ville-enfant-label">Le Département où se trouve l'enfant</InputLabel>
                <Select
                  labelId="ville-enfant-label"
                  value={ville}
                  label="Le Département où se trouve l'enfant"
                  onChange={handleVille}
                >
                  <MenuItem value="Brazzaville">Brazzaville</MenuItem>
                  <MenuItem value="Pointe_Noire">Pointe Noire</MenuItem>
                </Select>
                <p style={{ color: "red" }}>{msgVille}</p>
              </FormControl>

              <FormControl sx={{ width: '100%', mt: 2 }} disabled={!ville}>
                {/* Dépendances résidence: Ville -> Arrondissement -> Quartier */}
                <FormControl sx={{ width: '100%', mt: 2 }}>
                  <InputLabel id="ville-residence-label">Ville de résidence</InputLabel>
                  <Select
                    labelId="ville-residence-label"
                    value={villeResidence || ''}
                    label="Ville de résidence"
                    onChange={(e) => {
                      setShowValidation(true);
                      setVilleResidence(e.target.value);
                      setArrondissementResidence('');
                      setQuartierResidence('');
                    }}
                    disabled={!quartiersStructure?.villes?.length}
                  >
                    {(quartiersStructure?.villes || []).map((c) => (
                      <MenuItem key={c.ville} value={c.ville}>
                        {c.ville}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ width: '100%', mt: 2 }} disabled={!villeResidence}>
                  <InputLabel id="arrondissement-residence-label">Arrondissement de résidence</InputLabel>
                  <Select
                    labelId="arrondissement-residence-label"
                    value={arrondissementResidence || ''}
                    label="Arrondissement de résidence"
                    onChange={(e) => {
                      setShowValidation(true);
                      setArrondissementResidence(e.target.value);
                      setQuartierResidence('');
                    }}
                    disabled={!selectedCity?.arrondissements?.length}
                  >
                    {(selectedCity?.arrondissements || []).map((a) => (
                      <MenuItem key={a.arrondissement} value={a.arrondissement}>
                        {a.arrondissement}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ width: '100%', mt: 2 }} disabled={!arrondissementResidence}>
                  <InputLabel id="quartier-residence-label">Quartier de résidence</InputLabel>
                  <Select
                    labelId="quartier-residence-label"
                    value={quartierResidence || ''}
                    label="Quartier de résidence"
                    onChange={(e) => {
                      setShowValidation(true);
                      setQuartierResidence(e.target.value);
                    }}
                  >
                    {(quartiers || []).map((q) => (
                      <MenuItem key={q} value={q}>
                        {q}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <p style={{ color: "red" }}>{msgQuartierResidence}</p>
              </FormControl>
              
              <FormControl sx={{ width: '100%' }}>
                <PlacesAutocomplete
                  value={lieuTravail}
                  onChange={handleChangeLieuTravail}
                  onSelect={handleSelect}
                  searchOptions={{
                    componentRestrictions: { country: 'CG' }, // 'CG' est le code ISO 3166-1 alpha-2 pour la République du Congo
                    types: ['address'] // Limite les résultats aux adresses
                  }}
                >
                  {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div>
                      <TextField
                        type="text"
                        name="adresse"
                        label="Adresse complète où vit l'enfant"
                        className="w-100"
                        {...getInputProps({
                          placeholder: "Ex : 46 Rue Missakou, MOUKONDO",
                          variant: "outlined",
                          required: true,
                          error: Boolean(msgLieuTravail),
                          helperText: msgLieuTravail,
                          style: { marginBottom: '20px' }
                        })}
                      />
                      <div>
                        {loading && <div>Chargement...</div>}
                        {suggestions.map(suggestion => {
                          const style = {
                            backgroundColor: suggestion.active ? "#41b6e6" : "#fff"
                          };
                          return (
                            <div {...getSuggestionItemProps(suggestion, { style })}>
                              {suggestion.description}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
              </FormControl>

              <FormControl component="fieldset" sx={{ width: '100%', mt: 2, textAlign: 'left' }}>
                <InputLabel shrink>Cycles de l'élève</InputLabel>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <Checkbox
                      checked={cycleEleveArray.includes('congolais')}
                      onChange={() => toggleCycle('congolais')}
                    />
                    <span>Cycle congolais</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <Checkbox
                      checked={cycleEleveArray.includes('francais')}
                      onChange={() => toggleCycle('francais')}
                    />
                    <span>Cycle français</span>
                  </label>
                </Box>
                <p style={{ color: "red" }}>{msgCycleEleve}</p>
              </FormControl>

              <Box
                component="form"
                sx={{
                  '& .MuiTextField-root': { width: '100%' },
                }}
                noValidate
                autoComplete="off"
              >
              <TextField
                id="outlined-multiline-static"
                label="Donnez plus de détails sur les difficultés de l'élève"
                multiline
                placeholder='il/elle a des sérieux problèmes en lecture et écriture ...'
                rows={3}
                value={difficulte}
                variant="outlined"
                onFocus={() => setShowValidation(true)}
                onChange={e => setDifficulte(e.target.value)} 
                error={Boolean(msgDifficulte)}
                helperText={msgDifficulte || ''}
                style={{marginBottom: '20px'}}
              />
            </Box>


          <FormControl sx={{ width: '100%' }}>
              <InputLabel id="demo-multiple-checkbox-label">Jours disponibles de l'élève</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={joursName}
                onChange={handleChangeJours}
                input={<OutlinedInput label="Jours disponibles de l'élève" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {jours.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={joursName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
              
          </FormControl>
          <p style={{ color: "red",textAlign: 'center' }}>{msgJoursDisponibles}</p>
          <p>{joursName.length < 2 ? "":"Veuillez entrer les heures de disponibilité par jour"}</p>
          <p style={{fontWeight: 'bold'}}>        
            {joursName.length < 2 ? "":" - l'écart entre heures doit être au minimum de 2h"}
          </p>
          <p style={{fontWeight: 'bold'}}>        
            {joursName.length < 2 ? "":" - heures comprises entre 7h et 18h"}
          </p>
          
          {joursName.length >= 2 && Object.keys(disponibilites).map((jour) => (
            <div key={jour}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                type="time"
                label={`Heure de début (${jour})`}
                id={`${jour}-heureDebut`}
                name="heureDebut"
                value={disponibilites[jour].heureDebut || ""}
                onChange={(e) => handleChange(e, jour)}
                sx={{ m: 1, width: `calc(100% - ${(10 + 14 * jour.length)}px)` }}
              />
              <TextField
                type="time"
                id={`${jour}-heureFin`}
                label={`Heure de fin (${jour})`}
                name="heureFin"
                value={disponibilites[jour].heureFin || ""}
                onChange={(e) => handleChange(e, jour)}
                sx={{ m: 1, width: `calc(100% - ${(10 + 14 * jour.length)}px)` }}
              />
            </Box>
            </div>
          ))}

          <p style={{ color: "red",textAlign: 'center' }}>{msgHeuresSaisies}</p>
        </div>
    )
}

export default Step4